<section id="availability-form">
  <form [formGroup]="form">
    <div class='language-advisor-times'>
      <section class='language-advisor'>
        <div class='options'>
          
          <div *ngIf="source === 'dashboard' && apptType !== partsApptType" class="col-language">
            <span class="label-language-advisor">{{ 'serviceSchedule.transportOption' | translate }}</span>
            <mat-form-field appearance="outline" class="language">
              <mat-select class="my-class down" [(value)]="transportSelected" (selectionChange)="onSelectingPickupLocation($event.value)">
                <mat-option *ngFor="let transport of validTransport" [value]="transport.id">
                  {{ getTranslation(transport?.label) }}
                </mat-option>
              </mat-select>
              <div class="custom-arrow"></div>
            </mat-form-field>
          </div>

          <div class="col-language">
            <span class="label-language-advisor">{{ 'serviceSchedule.preferredLanguage' | translate}}</span>
            <mat-form-field appearance="outline" class="language">
              <mat-select class="my-class down" formControlName="languageId">
                <mat-option *ngFor="let language of languages | orderBy:'language'" [value]="language.languageId">
                  {{getLanguage(language.language)}}
                </mat-option>
              </mat-select>
              <div class="custom-arrow"></div>
          </mat-form-field>
          </div>

          <div class="col-language">
            <span class="label-language-advisor">{{options?.department?.toUpperCase() === 'SERVICE'? ('service.serviceAdvisor' |
              translate |
              titlecase) :('service.salesAdvisor' | translate | titlecase)}} </span>
            <mat-form-field appearance="outline" class="advisor">
              <mat-select class="my-class down" formControlName="advisorId" [(value)]="selected">
                <mat-select-trigger>
                  <span *ngFor='let advisor of advisors;let j = index'>
                    <img *ngIf='advisor.id == selected && advisor.id == -1' [src]='advisor.avatar'
                      class="selectedadvisor-profile-pic" (error)="setDefaultImg($event,'icons/unknown.svg')" alt="" />
                    <img
                      *ngIf='advisor.id == selected && advisor.id != -1 && advisor.avatar != "" && advisor.avatar != null'
                      [src]='advisor.avatar' class="selectedadvisor-profile-pic" (error)="errorLoadImage($event,j)"
                      alt="" />
                    <span
                      *ngIf='advisor.id == selected && advisor.id != -1 && (advisor.avatar == "" || advisor.avatar == null)'
                      class="selectedProfileImage">{{getProfileText(advisor.displayName)}}</span>
                    <span *ngIf='advisor.id == selected'>
                      {{advisor.displayName == 'Any advisor' ? (options?.department?.toUpperCase() === 'SERVICE'? ('testDrive.anyadvisor' |
                      translate):('testDrive.anyConsultant' | translate)) : advisor.displayName}}</span>
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor='let advisor of advisors;let i = index' [value]='advisor.id'>
                  <img [src]='advisor.avatar' *ngIf='advisor.id == -1' class="advisor-profile-pic"
                    (error)="setDefaultImg($event,'icons/unknown.svg')" alt="" />
                  <img [src]='advisor.avatar' *ngIf='advisor.id != -1 && advisor.avatar != "" && advisor.avatar != null'
                    class="advisor-profile-pic" alt="" (error)="errorLoadImage($event,i)" />
                  <span *ngIf='advisor.id != -1 && (advisor.avatar == "" || advisor.avatar == null)'
                    class="profileImage">{{getProfileText(advisor.displayName)}}</span>
                    {{advisor.displayName == 'Any advisor' ? (options.department?.toUpperCase() === 'SERVICE'? ('testDrive.anyadvisor' | translate):('testDrive.anyConsultant' | translate)) : advisor.displayName}}
                </mat-option>
              </mat-select>
              <div class="custom-arrow"></div>
            </mat-form-field>
          </div>

          <div class="col-language" *ngIf="apptType === 'Delivery' && options?.department?.toUpperCase() === 'SALES'">
            <span class="label-language-advisor">F&I</span>
            <mat-form-field appearance="outline" class="advisor">
              <mat-select class="my-class down" formControlName="fniAdvisorId">
                <mat-option *ngFor='let advisor of fniAdvisors' [value]='advisor.id'>
                  {{advisor.displayName}}
                </mat-option>
              </mat-select>
              <div class="custom-arrow"></div>
            </mat-form-field>
          </div>
        </div>
        <button *ngIf="showClearDateTimeBtn" mat-button class="clearBtn" [class.toShowBottom]="source === 'appointment'" (click)="onRemoveTimesSelected()">{{('delivery.clearDateTime' | translate)}}</button>

      </section>
      <div *ngIf="submitAllowed">
        <h6 class="submitNotAllowed"><asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>  {{ calenderMessage | translate}}</h6>
      </div>
      <div [ngClass]="disableCalendar ? 'disable-calender': ''">
      
      <section class='show-calendar' *ngIf="source !== 'sales'" [ngClass]="isDashBoard() ? 'rounded-corners' : '' ">
        <div *ngIf="availability.minDate" class='calendar' [ngClass]="{'dashboard-width': source === 'dashboard', 'default-width': source !== 'dashboard'}">
          <app-bdc-calendar [formControlName]="'appointmentStartDate'" [currentMonth]="currentMonth" [startAt]="availability.dayStartAt"
            [source]='source' [minDate]="availability.minDate" [maxDate]="availability.maxDate"
            [availableDates]="availableDates" [addLeaveService]="addLeaveService" (monthChanged)="onMonthChange($event)" (notifyParent)="getNotification($event)" [closedDates]="availability.offLeaveDays">
          </app-bdc-calendar>
        </div>
        <div class='slot-appointments' [ngClass]="{'dashboard-width': source === 'dashboard', 'default-width': source !== 'dashboard'}">
          <app-time-slot [timeSlots]="timeSlots" [isAvailabilityLoading]="isAvailabilityLoading" [source]='source'
            [formControlName]="'timeSlotId'" [override]="override" [isTimeSlotDisabled]="isTimeSlotDisabled"
            (timeSlotValidator)="emitTimeSlotValidator($event)" (disableOverride)="emitDisableOverride($event)"></app-time-slot>
        </div>
      </section>
    </div>
    </div>
  </form>
</section>